import React, { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import loadComponent from 'src/utils/loadMFE'
import { User } from 'types/orga'
import { useFlightDeck } from 'src/context/FlightDeckContext'
import RouteContainer from 'src/components/App/RouteContainer'

const UserList = React.lazy(() => loadComponent('orga', 'UserList'))

export function UserIndexRoute() {
    const navigate = useNavigate()
    const { company } = useFlightDeck()

    const onSelect = useCallback(
        (user: User) => {
            navigate(user._id)
        },
        [navigate],
    )

    return (
        <RouteContainer>
            <UserList onSelect={onSelect} currentCompany={company} title="Anwender" />
        </RouteContainer>
    )
}
